import React, { useEffect } from 'react';
import { html } from './Nucleo/PrivacyPolicy_gonucleo_and_GA_EN';
import { useDocumentTitle } from '../../../helpers/hooks';
import { BRANDING } from '../../../helpers/branding';
import { privacyPolicyHtmlIplsEn } from './IPLS/PrivacyPolicy_IPLS_EN';
import LegalContentFrame from './LegalContentFrame';

export default function PrivacyPolicyPage() {
  useDocumentTitle('Privacy Policy');

  useEffect(() => {
    if (BRANDING === 'IPLS') {
      window.location.href = 'https://ipls.online/privacy-policy';
    }
  }, []);

  if (BRANDING === 'NUCLEO') {
    return <LegalContentFrame html={html} title="Privacy Policy" />;
  }
  
  return null;
}
